import serviceFactory from "./service-factory";


export default new (serviceFactory('teachers', 'courses'))();

